var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.links.some((el) => el.desc)
    ? _c(
        "div",
        { staticClass: "summary" },
        [
          _c("SidebarTitle", { attrs: { title: _vm.title } }),
          _vm._v(" "),
          _vm._l(_vm.links, function (item, index) {
            return _c("div", { key: index, staticClass: "summary__links" }, [
              item.desc
                ? _c("p", { staticClass: "summary__links-title" }, [
                    _vm._v("\n      " + _vm._s(item.title) + "\n    "),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticClass: "summary__links-desc",
                  class: {
                    "summary__links-desc--blue": item.desc === "Licensing",
                    "summary__links-desc--red": item.desc === "Prohibited",
                  },
                },
                [_vm._v("\n      " + _vm._s(item.desc) + "\n    ")]
              ),
            ])
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }